import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Admin from "@/pages/Admin";
import { applySiteContent } from "@/data/content";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const el = document.querySelector(target);
      if (el) {
        setTimeout(() => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
          else el.scrollIntoView({ behavior: "smooth" });
        }, 80);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
};

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((res) => applySiteContent(res.data))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FDFBF7]">
        <p className="font-display text-xl italic text-[#8A6D1F]">Tarah</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FDFBF7] font-body text-[#1B3A6B] antialiased">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" theme="light" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
